import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { API } from "../context/AuthContext";
import Seo from "../components/Seo";
import SmartImage from "../components/SmartImage";
import { useLanguage } from "../context/LanguageContext";

export default function BlogPost() {
  const { language, t } = useLanguage();
  const { slug } = useParams();
  const nav = useNavigate();
  const [p, setP] = useState(null);

  useEffect(() => {
    axios.get(`${API}/blog/${slug}`).then(r => setP(r.data)).catch(() => nav("/blog"));
  }, [slug, nav]);

  if (!p) return <div className="max-w-[900px] mx-auto px-6 py-24 text-stone-500">{t("Caricamento…")}</div>;

  return (
    <article className="max-w-[900px] mx-auto px-6 lg:px-10 py-12">
      <Seo
        title={p.title}
        description={p.seo_description}
        path={`/blog/${p.slug}`}
        image={p.cover_image}
        type="article"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Article",
          "headline": p.title,
          "description": p.seo_description,
          "image": p.cover_image,
          "datePublished": p.published_at,
          "dateModified": p.updated_at,
          "author": { "@type": "Organization", "name": "Rarium Editorial" },
          "publisher": {
            "@type": "Organization",
            "name": "Rarium",
            "logo": { "@type": "ImageObject", "url": "https://rariumgroup.it/logo-mark.svg" }
          },
          "mainEntityOfPage": { "@type": "WebPage", "@id": `https://rariumgroup.it/blog/${p.slug}` },
          "articleSection": p.category,
        }}
      />

      <div className="text-sm text-stone-500 mb-8">
        <Link to="/blog" className="underline-hover">{t("Blog")}</Link> / <span className="capitalize">{(p.category || "").replace(/-/g," ")}</span>
      </div>

      <div className="overline text-[#8C3A3A] capitalize">{(p.category || "").replace(/-/g," ")}</div>
      <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl tracking-tighter leading-tight mt-3">{p.title}</h1>
      <div className="mt-4 text-sm text-stone-500">
        {p.published_at ? new Date(p.published_at).toLocaleDateString(language === "en" ? "en-IE" : "it-IT", { day: "numeric", month: "long", year: "numeric" }) : ""}
        {p.author ? ` · ${p.author}` : ""}
      </div>

      {p.cover_image && (
        <div className="mt-10 aspect-[16/9] bg-stone-100 overflow-hidden">
          <SmartImage src={p.cover_image} alt={p.title} className="w-full h-full object-cover" fallbackText={p.title} />
        </div>
      )}

      <div className="prose-rarium mt-12">
        <ReactMarkdown remarkPlugins={[remarkGfm]}>
          {p.body_markdown || ""}
        </ReactMarkdown>
      </div>

      <div className="mt-16 border-t border-stone-200 pt-8 flex flex-wrap gap-4 justify-between items-center">
        <Link to="/blog" className="underline-hover text-sm">{t("← Tutti gli articoli")}</Link>
        <Link to={`/category/${p.category}`} className="text-xs uppercase tracking-widest font-semibold bg-stone-900 hover:bg-[#8C3A3A] text-stone-50 px-6 py-3 transition-colors">
          {t("Esplora le aste")} →
        </Link>
      </div>
    </article>
  );
}
